/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    FC,
    $Container,
    ExtendContainerProps,
    getProp,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {Container as PixiContainer, Rectangle} from 'pixi.js';
import {PointerEvent, PointerEventHandler, getRoot} from './etc';

export type FullScreenSensorProps = ExtendContainerProps<{
    hitBoxContainer: PixiContainer|undefined;
    enable: boolean;
    onPointerMove: PointerEventHandler;
    onPointerUp: PointerEventHandler;
}>;

export const $FullScreenSensor: FC<FullScreenSensorProps> = (props) => {
    const container = new PixiContainer();
    const hitArea = new Rectangle(-1000000000, -1000000000, 2000000000, 2000000000);

    function getEventData(event: PointerEvent): PointerEvent {
        const data = event.data;
        const hitBoxContainer = getProp(props.hitBoxContainer);

        return {
            target: hitBoxContainer!,
            data: {global: data.global}
        };
    }

    function onPointerMove(event: PointerEvent) {
        if (event.target && getProp(props.hitBoxContainer)) {
            getProp(props.onPointerMove)(getEventData(event));
        }
    }

    function onPointerUp(event: PointerEvent) {
        if (event.target && getProp(props.hitBoxContainer)) {
            getProp(props.onPointerUp)(getEventData(event));
        }
    }

    const off = Store.effect(() => {
        const enable = getProp(props.enable);

        if (enable) {
            const root = getRoot(getProp(props.hitBoxContainer)!);

            root.addChild(container);
        } else {
            container.parent?.removeChild(container);
        }
    });

    return <$Container
        name='FullScreenSensor'
        instance={container}
        hitArea={hitArea}
        interactive
        buttonMode
        renderable={false}
        events={{
            pointermove: onPointerMove,
            pointerup: onPointerUp,
            pointerupoutside: onPointerUp,
            destroyed: off,
        }}
    />;
};